import useFlags from "./useFlags";

export default useFlags;
